import { api } from "../../api/endpoints";
import {
    GET_ONLY_PRICES,
    GET_SUBSCRIPTION_DETAILS_ERROR,
    GET_SUBSCRIPTION_DETAILS_SUCCESS,
    UPADTE_CUSTOMER_DETAILS,
    UPDATE_CUSTOMER_PM
} from "../constant";


export const getUserSubscriptions = (customerId) => {
    return async (dispatch) => {
        try {
            const customerDetailsRes = await api.post('/payment/getCustomerDetails', {customerId: customerId})
            const customerPaymentMethodsRes = await api.post('/payment/listUsersPaymentMethods', {customerId: customerId})
            const stripeCustomerDataRes = await api.post('/payment/getCustomerAndSubscriptions', {customerId: customerId})
            const pricesRes = await api.get('/payment/getPrices')
            dispatch({
                type: GET_SUBSCRIPTION_DETAILS_SUCCESS,
                payload: {
                    customerDetails: customerDetailsRes.data.customer,
                    customerPM: customerPaymentMethodsRes.data.methods,
                    subscriptionsDetails: stripeCustomerDataRes.data.customer,
                    prices: pricesRes.data.prices
                }
            })
        } catch (err) {
            dispatch({
                type: GET_SUBSCRIPTION_DETAILS_ERROR
            })
        }
    };
};

export const getPrices = () => {
    return async (dispatch) => {
        try {
            const pricesRes = await api.get('/payment/getPrices')
            dispatch({
                type: GET_ONLY_PRICES,
                payload: pricesRes.data.prices
            })
        } catch (err) {
            dispatch({
                type: GET_SUBSCRIPTION_DETAILS_ERROR
            })
        }
    }
}

export const updateCustomerDetails = (obj) => {
    return async (dispatch) => {
        dispatch({
            type: UPADTE_CUSTOMER_DETAILS,
            payload: obj
        })
    }
}

export const updateCustomerPM = (obj) => {
    return async (dispatch) => {
        dispatch({
            type: UPDATE_CUSTOMER_PM,
            payload: obj
        })
    }
}

